import './button.directive.ajscss';

import templateUrl from './button.directive.html';

export let ButtonDirective = () => ({
  restrict: 'E',
  transclude: false,
  scope: {
    icon: '@',
    label: '@',
    showLabel: '@',
    disabled: '@',
  },
  link: (scope, elem, attrs) => {
    scope.showLabel = scope.$eval(attrs.showLabel) || false;
    scope.disabled = scope.$eval(attrs.disabled) || false;

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  },
  templateUrl,
});

export default 'cngButton';
